/* unplugin-vue-components disabled */import script from "./ArtworkSpecialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtworkSpecialDialog.vue?vue&type=script&setup=true&lang=js"

import "./ArtworkSpecialDialog.vue?vue&type=style&index=0&id=71e0d1b2&lang=less"

const __exports__ = script;

export default __exports__